import _slicedToArray from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0c23cc46"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content-shape container pt-4"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("New message");

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" Only visible to group members ");

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" Submit ");

import { ref, reactive, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { sortBy } from "lodash";
import { useLoadingBar, useMessage } from "naive-ui";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { MessageModel, MessageValidator } from "@/schemes/message";
import { handleError } from "@/utils/errors";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var loadingBar = useLoadingBar();
    var messageAPI = useMessage();
    var LoaderState = LoaderStateEnum;
    var loaders = reactive({
      fetch: LoaderStateEnum.Idle,
      creation: LoaderStateEnum.Idle
    });
    var errors = reactive({});
    var model = reactive(_objectSpread({}, MessageModel));
    var rules = MessageValidator;
    var form = ref(null);
    var groups = ref([]);
    var languages = ref([]);
    var sortedGroups = computed(function () {
      return sortBy(groups.value, function (g) {
        return g.name;
      });
    });
    var languagesOptions = computed(function () {
      return _toConsumableArray(languages.value).map(function (_ref) {
        var label = _ref.label,
            code = _ref.code;
        return {
          label: label,
          value: code
        };
      });
    });
    var groupsOptions = computed(function () {
      if (groups.value.length === 0) {
        return [{
          label: "You are not part of any group yet",
          value: "none",
          disabled: true
        }];
      }

      var owned = sortedGroups.value.filter(function (g) {
        return g.isOwner;
      }).map(function (g) {
        return {
          label: g.name,
          value: g.groupId
        };
      });
      var others = sortedGroups.value.filter(function (g) {
        return !g.isOwner;
      }).map(function (g) {
        return {
          label: g.name,
          value: g.groupId
        };
      });
      if (owned.length === 0) return others;
      if (others.length === 0) return owned;
      return [{
        label: "My groups",
        value: "my-groups",
        disabled: true
      }].concat(_toConsumableArray(owned), [{
        label: "Group I belong to",
        value: "others-groups",
        disabled: true
      }], _toConsumableArray(others));
    });
    var restrictable = computed(function () {
      var _groups$value$find;

      return !!model.groupId && !((_groups$value$find = groups.value.find(function (g) {
        return g.groupId === model.groupId;
      })) !== null && _groups$value$find !== void 0 && _groups$value$find.isRoot);
    });

    var load = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _languages$value$find, _yield$Promise$all, _yield$Promise$all2, groupsResponse, languagesResponse, target;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loadingBar.start();
                loaders.fetch = LoaderStateEnum.Loading;
                _context.prev = 2;
                _context.next = 5;
                return Promise.all([http.get("/users/groups"), http.get("/ext/languages")]);

              case 5:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                groupsResponse = _yield$Promise$all2[0];
                languagesResponse = _yield$Promise$all2[1];
                groups.value = groupsResponse.data;
                languages.value = languagesResponse.data;
                model.language = (_languages$value$find = languages.value.find(function (l) {
                  return l.default;
                })) === null || _languages$value$find === void 0 ? void 0 : _languages$value$find.code;

                if (route.params.gid) {
                  target = groups.value.find(function (g) {
                    return String(g.groupId) === route.params.gid;
                  });

                  if (target) {
                    model.groupId = target.groupId;
                  } else {
                    messageAPI.error("The selected group cannot be found, please select one.");
                  }
                }

                loaders.fetch = LoaderStateEnum.Loaded;
                loadingBar.finish();
                _context.next = 24;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](2);
                _context.next = 21;
                return handleError(_context.t0, {
                  placeholder: "We were unable to retrieve your groups. If you don't want this message to be public, please reload the page."
                });

              case 21:
                errors.fetch = _context.sent;
                loaders.fetch = LoaderStateEnum.Failed;
                loadingBar.error();

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 17]]);
      }));

      return function load() {
        return _ref2.apply(this, arguments);
      };
    }();

    var create = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var payload, _yield$http$post, message;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (form.value) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return form.value.validate();

              case 5:
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", false);

              case 10:
                loaders.creation = LoaderStateEnum.Loading;
                _context2.prev = 11;
                payload = {
                  content: model.content,
                  isPublic: !model.groupId || !model.restricted,
                  language: model.language
                };

                if (model.groupId) {
                  payload.groupsIds = [model.groupId];
                }

                _context2.next = 16;
                return http.post("/messages", payload);

              case 16:
                _yield$http$post = _context2.sent;
                message = _yield$http$post.data;

                if (model.content === payload.content) {
                  model.content = "";
                }

                loaders.creation = LoaderStateEnum.Loaded;
                messageAPI.success("The message has been created");
                _context2.next = 23;
                return router.push({
                  name: "Message",
                  query: {
                    k: message.key
                  }
                });

              case 23:
                _context2.next = 31;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t1 = _context2["catch"](11);
                _context2.next = 29;
                return handleError(_context2.t1);

              case 29:
                errors.creation = _context2.sent;
                loaders.creation = LoaderStateEnum.Failed;

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 7], [11, 25]]);
      }));

      return function create() {
        return _ref3.apply(this, arguments);
      };
    }();

    load();
    return function (_ctx, _cache) {
      var _component_n_h1 = _resolveComponent("n-h1");

      var _component_n_alert = _resolveComponent("n-alert");

      var _component_n_skeleton = _resolveComponent("n-skeleton");

      var _component_n_select = _resolveComponent("n-select");

      var _component_n_form_item = _resolveComponent("n-form-item");

      var _component_n_input = _resolveComponent("n-input");

      var _component_n_checkbox = _resolveComponent("n-checkbox");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_form = _resolveComponent("n-form");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_n_h1, null, {
        default: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      }), _unref(loaders).fetch === _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_alert, {
        key: 0,
        type: "warning",
        size: "small",
        class: "special-alert white-space-pre-line mb-4",
        "show-icon": false
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref(errors).fetch), 1)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_n_form, {
        model: _unref(model),
        ref_key: "form",
        ref: form,
        rules: _unref(rules)
      }, {
        default: _withCtx(function () {
          return [_unref(loaders).fetch === _unref(LoaderState).Loading || languages.value.length > 0 ? (_openBlock(), _createBlock(_component_n_form_item, {
            key: 0,
            path: "language",
            label: "Language"
          }, {
            default: _withCtx(function () {
              return [_unref(loaders).fetch === _unref(LoaderState).Loading ? (_openBlock(), _createBlock(_component_n_skeleton, {
                key: 0,
                sharp: false,
                class: "skeleton-input"
              })) : (_openBlock(), _createBlock(_component_n_select, {
                key: 1,
                value: _unref(model).language,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(model).language = $event;
                }),
                options: _unref(languagesOptions),
                disabled: _unref(loaders).fetch === _unref(LoaderState).Failed,
                filterable: ""
              }, null, 8, ["value", "options", "disabled"]))];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_n_form_item, {
            path: "groupId",
            label: "Group"
          }, {
            default: _withCtx(function () {
              return [_unref(loaders).fetch === _unref(LoaderState).Loading ? (_openBlock(), _createBlock(_component_n_skeleton, {
                key: 0,
                sharp: false,
                class: "skeleton-input"
              })) : (_openBlock(), _createBlock(_component_n_select, {
                key: 1,
                value: _unref(model).groupId,
                "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
                  return _unref(model).groupId = $event;
                }),
                options: _unref(groupsOptions),
                disabled: _unref(loaders).fetch === _unref(LoaderState).Failed,
                filterable: "",
                clearable: "",
                placeholder: "Without selection, your message will be public"
              }, null, 8, ["value", "options", "disabled"]))];
            }),
            _: 1
          }), _createVNode(_component_n_form_item, {
            path: "content",
            label: "Message"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_input, {
                "input-props": {
                  autocomplete: 'off'
                },
                type: "textarea",
                autosize: {
                  minRows: 3
                },
                value: _unref(model).content,
                "onUpdate:value": _cache[2] || (_cache[2] = function ($event) {
                  return _unref(model).content = $event;
                })
              }, null, 8, ["value"])];
            }),
            _: 1
          }), _withDirectives(_createVNode(_component_n_form_item, {
            path: "restricted",
            "show-label": false
          }, {
            default: _withCtx(function () {
              return [_withDirectives(_createVNode(_component_n_checkbox, {
                checked: _unref(model).restricted,
                "onUpdate:checked": _cache[3] || (_cache[3] = function ($event) {
                  return _unref(model).restricted = $event;
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_3];
                }),
                _: 1
              }, 8, ["checked"]), [[_vShow, _unref(restrictable)]])];
            }),
            _: 1
          }, 512), [[_vShow, _unref(restrictable)]]), _createElementVNode("div", null, [_createVNode(_component_n_button, {
            type: "primary",
            disabled: _unref(loaders).fetch === _unref(LoaderState).Loading,
            loading: _unref(loaders).creation === _unref(LoaderState).Loading,
            onClick: create
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1
          }, 8, ["disabled", "loading"])]), _unref(loaders).creation === _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 1,
            type: "error",
            class: "white-space-pre-line mt-3",
            "show-icon": false
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(errors).creation), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});